import { Component } from "@angular/core";
import { FormArray, FormBuilder, FormControl, Validators } from "@angular/forms";
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { SuperAdminService } from "src/app/super-admin/super-admin.service";
import { MatDialog } from '@angular/material/dialog';
import { ViewLogs } from "src/app/sharedModule/view_logs/view_logs.component";
import { ReportService } from "src/app/sharedModule/report-v2/services/report.service";
import { getCurrentUser } from 'src/app/authModule/state/authentication.selectors';
import { Store } from '@ngrx/store';
import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from "src/app/sharedModule/report-v2/services/language.service";
import { TableColumn } from '../../shared/components/app-table/app-table.component';

interface RequestFilters {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-access-content-admin',
  templateUrl: './access-content.component.html',
  styleUrls: ['./access-content.component.scss']
})

export class AccessContentAdmin {
  request_filters: RequestFilters[] = [
    { value: 'show_all', viewValue: this.translate.instant('new_entries.show_all') },
    { value: 'your_requests', viewValue: this.translate.instant('new_entries.your_institution_requests') },
    { value: 'other_requests', viewValue: this.translate.instant('new_entries.other_institution_requests') },
  ];
  selectedRequestFilter = this.request_filters[0].value;
  user: any;

  // Table configuration
  tableColumns: TableColumn[] = [
    { key: 'requesterName', label: 'new_entries.requester_name', type: 'text' },
    { key: 'institutionName', label: 'new_entries.institution_name', type: 'text' },
    { key: 'documentTitle', label: 'new_entries.document_title', type: 'text' },
    { key: 'requestDate', label: 'new_entries.request_date', type: 'template', templateKey: 'requestDateTemplate' },
    { key: 'auditLog', label: 'new_entries.audit_log', type: 'template', templateKey: 'auditLogTemplate' },
    { key: 'status', label: 'new_entries.status', type: 'template', templateKey: 'statusTemplate' }
  ];

  mappedRequests: any[] = [];

  constructor(private dialog: MatDialog, private reportService: ReportService, private store: Store, private translate: TranslateService, private languageService: LanguageService) {

  }

  requests;
  filteredRequests: any[] = [];

  ngOnInit(): void {

    const storedLanguage = localStorage.getItem('websiteLanguage');
    const language = storedLanguage ? storedLanguage : 'en';

    this.translate.use(language);
    this.languageService.selectedLanguage$.subscribe((language: string) => {
      this.translate.use(language);
    });

    this.translate.onLangChange.subscribe((event) => {
      this.request_filters = [
        { value: 'show_all', viewValue: this.translate.instant('new_entries.show_all') },
        { value: 'your_requests', viewValue: this.translate.instant('new_entries.your_institution_requests') },
        { value: 'other_requests', viewValue: this.translate.instant('new_entries.other_institution_requests') },
      ];

    });

    this.reportService
      .getContentRequest()
      .pipe()
      .subscribe(
        (data) => {
          this.requests = data;
          this.filterRequests();
        },
        (error) => {
        }
      );

    this.store.select(getCurrentUser).subscribe((data) => {
      if (data !== null) {
        this.user = data;
        this.filterRequests();
      }
    });
    this.filterRequests();
  }

  ngDoCheck() {
    if (localStorage.getItem('websiteLanguage') !== this.translate.currentLang) {
      this.translate.use(localStorage.getItem('websiteLanguage'));
    }
  }

  filterRequests(): void {
    if (this.selectedRequestFilter === 'show_all') {
      this.filteredRequests = this.requests;
    } else if (this.selectedRequestFilter === 'your_requests') {
      this.filteredRequests = this.requests.filter(
        (request) => request.institutionId === this.user?.institutionId
      );
    } else if (this.selectedRequestFilter === 'other_requests') {
      this.filteredRequests = this.requests.filter(
        (request) => request.institutionId !== this.user?.institutionId
      );
    }

    // Map data for table
    if (this.filteredRequests) {
      this.mappedRequests = this.filteredRequests.map(request => this.mapRequestToTableRow(request));
    }
  }

  openViewLogs(request, expandable) {

    this.dialog.open(ViewLogs, {
      data: {
        requestType: this.selectedRequestFilter,
        expandable: expandable,
        request
      },
      height: '80%',
      width: '50%'
    })
  }

  changeAccess(requestId, access) {


    this.reportService
      .changeContentRequestAccess(requestId, !access)
      .pipe()
      .subscribe(
        (data) => {
          this.requests.forEach(element => {
            if (element.id == requestId) {
              element.status = !access
            }
          });
          this.filterRequests();
        },
        (error) => {
        }
      );
  }

  mapRequestToTableRow(request: any): any {
    return {
      id: request.id,
      requesterName: request.user.name,
      institutionName: request.user.Institution.name,
      documentTitle: request.submissions.title,
      requestDate: request.createdAt,
      auditLog: request,
      status: request,
      originalData: request
    };
  }

}
